import { RouterStore } from 'mobx-react-router';
import { useContext } from 'react';
import { GlobalContext } from '../../mainv3/contexts/global';

export const useRouter = (): RouterStore => {
    const { routing } = useContext(GlobalContext);
    return routing;
};
